import { FC } from "react";
import Translate from "../Translate/Translate";

/**
 * Members may need labs ready beforehand for their first visit of any
 * appointment type, so we nudge them while picking a date. Once they've
 * already had a visit of that type, or once labs are already complete, they
 * don't need the reminder.
 * See https://9amhealth.atlassian.net/wiki/spaces/PRODUCT/pages/1622802448
 */
const LabsHint: FC<{ show: boolean }> = ({ show }) => {
  if (!show) {
    return null;
  }

  return (
    <p>
      <Translate msg="appointment.schedule.labsHint" />
    </p>
  );
};

export default LabsHint;
